import { InteractionRequiredAuthError, type IPublicClientApplication, type AccountInfo } from "@azure/msal-browser";
import { loginRequest, apiTokenRequest } from "./msalConfig";
import { setPostLoginHash } from "@/helpers/setPostLoginHash";

export function getActiveAccount(instance: IPublicClientApplication): AccountInfo | null {
    const active = instance.getActiveAccount();
    if (active) return active;

    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
        instance.setActiveAccount(accounts[0]);
        return accounts[0];
    }
    return null;
}

export async function login(instance: IPublicClientApplication) {
    await safeLoginRedirect(instance);
}

export async function logout(instance: IPublicClientApplication) {
    sessionStorage.removeItem("postLoginHash");
    sessionStorage.removeItem("lastRoute");

    const account = getActiveAccount(instance);

    await instance.logoutRedirect({ 
        account: account ?? undefined,
        postLogoutRedirectUri: window.location.origin
    });
}

function isInteractionInProgress(): boolean {
    // MSAL gebruikt sessionStorage om status bij te houden
    // (key is per versie wat anders; dit werkt in praktijk vaak genoeg)
    return Object.keys(sessionStorage).some(k => k.includes("interaction.status"));
}

async function safeLoginRedirect(instance: IPublicClientApplication) {
    if (isInteractionInProgress()) return;
    setPostLoginHash();
    await instance.loginRedirect(loginRequest); // Use basic login, not API scope
}

export async function acquireApiToken(instance: IPublicClientApplication): Promise<string | null> {
    const account = getActiveAccount(instance);

    if (!account) {
        await safeLoginRedirect(instance);
        return null;
    }

    try {
        const result = await instance.acquireTokenSilent({ ...apiTokenRequest, account });
        return result.accessToken;
    } catch (e: any) {
        if (e instanceof InteractionRequiredAuthError) {
            window.location.href = '/access-denied';
            return null;
        }

        if (e?.errorCode === "interaction_in_progress") {
            return null;
        }

        throw e;
    }
}
